import { Box, styled } from '@mui/material';

export const MenuIconWrapper = styled(Box)`
  width: 20px;
  display: inline-flex;
  justify-content: center;
  margin-right: 8px;
`;
